@if (loginDisplay) {
  <app-header></app-header>
  <section class="flex-1 p-8 rounded-sm h-[calc(100%-164px)] bg-grey-50">
    <router-outlet></router-outlet>
  </section>
  <div class="h-[100px] bg-scania-blue p-[40px] flex justify-between">
    <span class="text-grey-500"> Copyright © {{ year }} Scania</span>
    <span class="brand"></span>
  </div>
} @else {
  <section class="flex flex-col gap-10 items-center justify-center h-full bg-scania-blue">
    <img src="scania-logo.svg" alt="Scania" class="w-[300px]">
    <h1 class="text-5xl">FLEET WORK</h1>
  </section>
}

